import Widget from "@arcgis/core/widgets/Widget";
import { Layer } from './layers'

import TimeSlider from "./timeslider"
import LayerSelector from "./layerselector"
import PresetPanel from "./presetpanel"
import QueryWidget from "./querywidget"
import ValueSlider from "./valueslider"
import SublayerselectorWidget from "./sublayerselector"

export interface WidgetBuilderSettings {
    id: string,
    type: string,
    settings: any,
    layer?: any
}

interface Widgets {
    [key: string]: Widget | null
}

export let widgets: Widgets = {}

let controlsPanelId: string = "layer-controls-list"

let widgetIdPrefix: string = "widgetid-"

let currentlyInControlPanel: string[] = []

export let returnToPanel: string | null = null

export function clearControlsPanel() {
    $('#' + controlsPanelId).html('')
    for (let id of currentlyInControlPanel) {
        widgets[id] = null
    }
    currentlyInControlPanel = []
}

export function loadLayerControlPanel(layer: Layer, returnPanel?: string) {
    loadWidgetsIntoControlPanel(layer.controls, layer)
    if (returnPanel) {
        returnToPanel = returnPanel
    }
}

export function loadWidgetsIntoControlPanel(widgets: WidgetBuilderSettings[], layer?: Layer) {
    clearControlsPanel()

    for (let widgetParams of widgets) {
        if (!widgetParams.settings.container) {
            widgetParams.settings.container = widgetIdPrefix + widgetParams.id;
        }
        $('#' + controlsPanelId).append('<div id="' + widgetParams.settings.container +'"></div>')
        if (buildWidget(widgetParams, layer)) {
            currentlyInControlPanel.push(widgetParams.id)
        }
    }
}

export function buildWidget(params: WidgetBuilderSettings, layer?: Layer, extras?: any): Widget | null {
    if (!params.settings.container) {
        params.settings.container = widgetIdPrefix + params.id;
    }
    if (layer && !params.settings.layer) {
        params.settings.layer = layer
    }

    if (extras) {
        for (let key in extras) {
            params.settings[key] = extras[key]
        }
    }

    if (params.type == "TimeSlider") {
        // @ts-ignore
        widgets[params.id] = new TimeSlider(params.settings)
    } else if (params.type == "LayerSelector") {
        // @ts-ignore
        widgets[params.id] = new LayerSelector(params.settings)
    } else if (params.type == "PresetPanel") {
        // @ts-ignore
        widgets[params.id] = new PresetPanel(params.settings)
    } else if (params.type == "QueryWidget") {
        // @ts-ignore
        widgets[params.id] = new QueryWidget(params.settings)
    } else if (params.type == "ValueSlider") {
        // @ts-ignore
        widgets[params.id] = new ValueSlider(params.settings)
    } else if (params.type == "SublayerselectorWidget") {
        // @ts-ignore
        widgets[params.id] = new SublayerselectorWidget(params.settings)
    }

    return widgets[params.id];
}